import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import MediaQuery from 'react-responsive'
import styled from 'styled-components'

import Screen, { ScreenContentContainer } from './Screen'
import CElementView from '../View/CElementView'
import ConnectedDotLinkView from '../View/ConnectedDotLinkView'
import Image from '../View/Image'

const CScreen = styled(Screen)`

h1 {
  font-size: 2em;
  @media(max-width: 414px) {
    font-size: 1.33em;
  }
}

#logo {
  margin: 60px 0;
}

#navigation {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 60px 0;
}
`

const COuterContainer = styled.div`
display: flex;
justify-content: center;
align-items: top;
`

const LinkContainer = styled.div`
height: 100%;

.link {
  position: fixed;
  top: calc(50% - (120px * 0.5));
  opacity: 0.33;
}

.link:hover {
  opacity: inherit;
}

.prev {
  left: 60px;
}

.next {
  right: 60px;
}
`

const CElementsView = props => {
  if (props.elements === undefined) {
    return null
  }
  const CElementsViewInner = styled.div`
    width: 100%;
  `
  const elementViews = props.elements.map((element, i) => <CElementView element={element} key={i} />)
  return <CElementsViewInner>{elementViews}</CElementsViewInner>
}

class C extends Component {

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      window.scrollTo(0, 0)
    }
  }
  
  render() {
    const { cData } = this.props
    const elements = (cData !== null) ? cData.elements() : []
    return (
      <CScreen>
      <Helmet>
      <title>Welcome Seminar</title>
      </Helmet>
      <MediaQuery query="(min-width: 1112px)">
      <COuterContainer>
      { cData && cData.prevConnectedDot && <LinkContainer><ConnectedDotLinkView connectedDot={cData.prevConnectedDot} className="link prev"/></LinkContainer> }
      <ScreenContentContainer>
      <h1 id="logo"><Link to="/"><Image name="welcome-seminar-logo" alt="Welcome Seminar ロゴ"/></Link></h1>
      <CElementsView elements={elements} />
      </ScreenContentContainer>
      { cData && cData.nextConnectedDot && <LinkContainer><ConnectedDotLinkView connectedDot={cData.nextConnectedDot} className="link next"/></LinkContainer> }
      </COuterContainer>
      </MediaQuery>
      <MediaQuery query="(max-width: 1111px)">
      <ScreenContentContainer>
      <h1 id="logo"><Link to="/"><Image name="welcome-seminar-logo" alt="Welcome Seminar ロゴ"/></Link></h1>
      <CElementsView elements={elements} />
      <div id="navigation">
      <div className="link prev">{ cData && cData.prevConnectedDot && <ConnectedDotLinkView connectedDot={cData.prevConnectedDot} /> }</div>
      <div className="link prev">{ cData && cData.nextConnectedDot && <ConnectedDotLinkView connectedDot={cData.nextConnectedDot} /> }</div>
      </div>
      </ScreenContentContainer>
      </MediaQuery>
      </CScreen>
    )
  }
  
  _renderDots(dots) {
    return dots.map((dot, i) => <CElementView key={i} dot={dot} style={{margin: "0 0"}}/>)
  }
}

export default C


// WEBPACK FOOTER //
// ./src/App/Page/C.js